<template>
  <VContainer fluid class="grad fill-height d-flex align-center justify-center">
    <VRow class="w-100" align="center" justify="center">
      <VCol cols="12" class="text-center">
        <VCard color="transparent" class="elevation-0">

          <VCardTitle class="justify-center">
            <VImg
              style="margin: auto;"
              max-width="500px"
              :src="titleNegativo"
            />
          </VCardTitle>

          <VCardTitle class="text-h2 mt-6 text-white font-weight-bold justify-center text-center">
            {{ $t('HOME.success') }}!
          </VCardTitle>

          <VCardTitle
            class="text-h5 mt-6 text-white font-weight-bold justify-center text-center"
            style="white-space: pre-line;"
          >
            {{ $t('HOME.success_description') }}.
          </VCardTitle>

          <VCardActions class="justify-center">
            <VContainer class="d-flex justify-center text-white" style="white-space: pre-line;" fluid>
              <table class="mx-auto text-center">
                <thead>
                  <tr>
                    <th colspan="2" class="text-center">
                      <div class="text-h6 font-weight-medium">
                        {{ $t('PRE_FOOTER.contacts') }}
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="text-h6 font-weight-light">
                    <td><VIcon class="text-white">mdi-email</VIcon></td>
                    <td>info@reportlake.com</td>
                  </tr>
                  <tr class="text-h6 font-weight-light">
                    <td><VIcon class="text-white">mdi-clock</VIcon></td>
                    <td>{{ $t('PRE_FOOTER.work_week') }} - 9h {{ $t('PRE_FOOTER.to') }} 18h</td>
                  </tr>
                </tbody>
              </table>
            </VContainer>
          </VCardActions>

        </VCard>
      </VCol>
    </VRow>
  </VContainer>
</template>

<script>
import titleNegativo from '@/assets/icons/title_negativo.png'

export default {
  name: 'Success',
  data () {
    return { titleNegativo }
  },
  mounted () {
    if (this.$route.name === 'success-qr') {
      this.$gtag.event('success_evento_1', {
        event_category: 'SucessoEvento1',
        event_label: 'SucessoEvento1',
        value: 'success_evento_1'
      })
    }
  }
}
</script>

<style>
.grad {
  background-image: linear-gradient(#0B0E17, #3D4A6D);
  min-height: 100vh; /* garante altura total do ecrã para centrar verticalmente */
}

/* opcional: remove espaços extra do VRow em layouts simples */
.w-100 { width: 100%; }

.semi-circle-success {
  --shadow-size: 4vmin;
  aspect-ratio: 1;
  background: #3D4A6D;
  border-radius: 50%;
  box-shadow:
    var(--shadow-size) var(--shadow-size) 0 var(--shadow-size) #364363,
    calc(2 * var(--shadow-size)) calc(2 * var(--shadow-size)) 0 calc(2 * var(--shadow-size)) #26324C;
  width: 90vmin;
  position: absolute;
  bottom: 100%;
  right: 100%;
  transform: translate(75%, 75%);
  z-index: 1;
}
</style>
